import type { Property } from 'csstype'
import { ButtonHTMLAttributes, PropsWithChildren } from 'react'

import { ButtonStyled } from './Button.styled'
import { ButtonHeight, ButtonMinWidth, ButtonThemeType } from './types'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  buttonTheme?: ButtonThemeType
  textWrap?: Property.TextWrap
  minWidth?: ButtonMinWidth
  buttonHeight?: ButtonHeight
}

export const Button = ({
  children,
  type = 'button',
  buttonTheme = 'blue',
  ...buttonProps
}: PropsWithChildren<ButtonProps>) => {
  return (
    <ButtonStyled type={type} buttonTheme={buttonTheme} {...buttonProps}>
      {children}
    </ButtonStyled>
  )
}
